exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb-icon-mobile[data-v-2203b2f6]{\r\n  font-size: 19px;\r\n  vertical-align: text-bottom;\n}\r\n", ""]);

// exports
